import {
  EXTENDED_WARRANTY_2YEAR_ID,
  EXTENDED_WARRANTY_3YEAR_ID,
} from '@/app/[locale]/store/_consts';

import WarrantySelection from '../_steps/enums/WarrantySelection';

export default function getExtendedWarrantyId(
  selection: WarrantySelection | undefined,
): number | null {
  switch (selection) {
    case WarrantySelection.TwoYear:
      return EXTENDED_WARRANTY_2YEAR_ID;

    case WarrantySelection.ThreeYear:
      return EXTENDED_WARRANTY_3YEAR_ID;

    case WarrantySelection.OneYear:
    default:
      return null;
  }
}
